import { render, staticRenderFns } from "./EditModel.vue?vue&type=template&id=83490262&"
import script from "./EditModel.vue?vue&type=script&lang=js&"
export * from "./EditModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports